module.exports = "https://cdn-assessment.mathletics.com/app/104/assets/images/4f6c1126d3155b37e0e493b37624536e.svg";